export default "__VITE_ASSET__7c8fb163__"